import { render, staticRenderFns } from "./quote-locations.vue?vue&type=template&id=52b549be&"
import script from "./quote-locations.vue?vue&type=script&lang=js&"
export * from "./quote-locations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports